
































import {Emit} from "vue-property-decorator";
import {InOut} from 'vue-inout-prop-decorator';
import {Component, Vue} from '@/shared/component';

import {Pile} from '@/models';

import CrudPileShow from '@/components/Crud/Pile/Show.vue';

@Component({
	components: {
		CrudPileShow,
	}
})
export default class CrudPileShowDialog extends Vue {
	@InOut({ type: Pile  , isVModel: true }) private value!: Pile;
	
	@Emit()
	public onClose() {
		this.value = null;
	}
}
